<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <Migalha label="Termo de Concordância e Veracidade"></Migalha>
    <v-card>
      <v-form ref="formPesquisar" v-model="valid">
        <v-layout row wrap>
          <v-flex xs12 sm6 md3 p-t-20>
            <v-select
              v-model="model.situacaoTermoVeracidade"
              :items="enumSituacaoTermoVeracidadeResumido"
              item-text="descricao"
              item-value="valor"
              :label="$t('label.situacaoSolicitacao')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md4 p-t-20>
            <v-select
              v-model="model.tipoSolicitacao"
              :items="enumTtipoSolicitacao"
              item-text="descricao"
              item-value="valor"
              :label="$t('label.tipoSolicitacao')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md5 p-t-20>
            <fieldset>
              <legend>Natureza</legend>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-switch
                    v-model="model.tipFornecedor"
                    :label="$t('label.pessoaJurica')"
                    color="info"
                    value="J"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex xs6>
                  <v-switch
                    v-model="model.tipFornecedor"
                    :label="$t('label.pessoaFisica')"
                    color="info"
                    value="F"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>
          <v-flex xs4 sm4 md4>
          <v-text-field
            v-model="model.numCgcFornecedor"
            :label="(model.tipFornecedor =='J') ? $t('label.cnpj') : (model.tipFornecedor =='F') ? $t('label.cpf') : $t('label.cpfCnpj')"
            @input="model.numCgcFornecedor = $event.toUpperCase()"
            maxlength="18"
          >
            <the-mask
              slot-scope="{ on, attrs }"
              v-bind="attrs"
              v-on="on"
              v-model="model.numCgcFornecedor"
              :mask="getCpfCnpjMask()"
              :tokens="{ 
                'X': { pattern: /[0-9a-zA-Z]/, persistent: true } 
              }"
              masked
            />
          </v-text-field>
          </v-flex>
          <v-flex xs5 sm5 md5>
            <v-text-field
              v-model="model.nomFornecedor"
              :label="(model.tipFornecedor =='J') ? $t('label.razaoSocial') : $t('label.razaoSocial') +'/'+ $t( 'label.nome') "
            ></v-text-field>
          </v-flex>
             <v-flex xs3 sm3 md3 p-t-20>
            <fieldset>             
              <v-layout row wrap>
                <v-flex xs6>
                  <v-switch
                    v-model="model.assinadoDigitalmente"
                    :label="$t('label.assinaturaDigital')"
                    color="info" 
                    false-value="" 
                    true-value="1"              
                    hide-details
                  ></v-switch>
                </v-flex>                
              </v-layout>
            </fieldset>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <datePicker
              v-model="model.dataSolicitacao"
              v-mask="maskData"
              :dataDefault="model.dataSolicitacao"
              :label="$t('label.dataInicio')"
              :rules="[]"
            />
          </v-flex>
          <v-flex xs12 sm6 md4>
            <datePicker
              v-model="model.dataFinalSolicitacao"
              v-mask="maskData"
              :dataDefault="model.dataFinalSolicitacao"
              :label="$t('label.dataFinal')"
              :rules="[]"
            />
          </v-flex>

          <v-flex xs12 sm6 md4>
             <v-text-field
              v-model="model.numeroSolicitacao"
              :label="$t('label.numeroSolicitacao')"
              :rules="[]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-combobox
                  v-model="model.analista"
                  :return-object="true"
                  :items="comboAnalistasFiltro"
                  :label="$t('label.analista')"
                  item-text="nome"
                  clearable
                ></v-combobox>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-combobox
                  v-model="model.localidade"
                  :items="comboLocalidades"
                  :label="$t('label.localidades')"
                  item-text="nome"
                ></v-combobox>
          </v-flex>

          <v-flex  xs12 sm6 md4>
            <v-switch
              v-model="model.filtroSolicitacoesVencidas"
              :label="$t('label.solicitacoesVencidas')"
              true-value="1"  
              false-value="0">
            ></v-switch>
          </v-flex>

          <v-flex xs8 sm10 md3  p-t-15>
            <v-btn large color="info" @click="carregarTabelaCadastrados(true)">Pesquisar</v-btn>
          </v-flex>

          <v-flex xs4 sm2 md1 p-t-15>
          <a color="info" @click="exportarExcel()">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
          width="48" height="48"
          viewBox="0 0 192 192"
          style=" fill:#000000;">
          <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,192v-192h192v192z" fill="none"></path><g fill="#2ecc71">
            <path d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z"></path></g></g></svg>
          </a>
          </v-flex>

        </v-layout>
      </v-form>
      <v-flex>
        <v-data-table
                :headers="headers"
                :items="listaFornec"
                :pagination.sync="pagination"
                :disable-initial-sort="true"
                class="tableLista"
                :total-items="pagination.totalItems"
                :rowsPerPageItems="[pagination.rowsPerPage]"
                >
          <template slot="items" slot-scope="props">


            <!-- Ajeitar as tds a partir daqui -->
          <td nowrap="nowrap" class="text-xs-center">
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  icon 
                  @click="props.item.hasTermoConcordanciaVeracidade ? atualizarSituacaoSolicitacao(props.item,enumSituacaoTermoVeracidade.filter(x=>x.chave === 'Aceitar')[0].valor) : exibeErroTermo()"
                >
                  <v-icon :color="defineCorIconeSolicitacao(props.item.situacaoSolicitacao)">spellcheck</v-icon>
                </v-btn>
                <span v-if="enumSituacaoTermoVeracidade.filter(x => x.chave === 'Aceitar')[0]">
                    {{ enumSituacaoTermoVeracidade.filter(x => x.chave === 'Aceitar')[0].descricao }}
                  </span>
              </v-tooltip>
              <v-tooltip top >
                <v-btn 
                  slot="activator" 
                  icon 
                  @click="props.item.hasTermoConcordanciaVeracidade ? openModalRejetar(props.item) : exibeErroTermo()"
                >
                  <v-icon color="red">cancel</v-icon>
                </v-btn>
                   <span v-if="enumSituacaoTermoVeracidade.filter(x => x.chave === 'Rejeitar')[0]">
                    {{ enumSituacaoTermoVeracidade.filter(x => x.chave === 'Rejeitar')[0].descricao }}
                  </span>
              </v-tooltip>
                  
              <v-tooltip top>
                <v-btn icon slot="activator" @click="openModalUploadTermo(props.item)">
                <v-icon v-if="props.item.hasTermoConcordanciaVeracidade" color="blue">attach_file</v-icon>
                <v-icon v-else color="grey">attach_file</v-icon>
                </v-btn>
                <span>Anexar Termo</span>
              </v-tooltip>
            </td>

            <td nowrap v-bind:class="{'cpf-servidor':props.item.isFuncionarioPublico || props.item.fornecedoresHabilitacaoJuridica.find(x => x.isFuncionarioPublico), 'dataVencida':props.item.validadeSolicitacao =='1'}">
              <a v-show="props.item.isFuncionarioPublico || props.item.fornecedoresHabilitacaoJuridica.find(x => x.isFuncionarioPublico)">
                <v-tooltip top>                
                  <v-icon        
                    class="mx-1"
                    slot="activator"
                    :size="20"
                    color="red"
                  >info</v-icon>
                  <span>Esta solicitação contém CPF de Servidor Público</span>    
                </v-tooltip>
              </a>
              {{ props.item.numCgcFornecedor | formatCpfCnpj }}
              <span class='tooltipHint' v-show='props.item.tipoSolicitacao==2'>
                *Solicitação Alteração
              </span>
            </td>
            <td class="text-xs-left" nowrap
              v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.nomFornecedor }}
            </td>
            <td class="text-xs-left" nowrap
              v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.numSolicitacao }}
            </td>
            <td class="text-xs-center" nowrap
              v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.dataSolicitacao | dataHoraFormatada }}
            </td>
            <td class="text-xs-left" nowrap
             v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
                <div v-if="props.item.situacaoSolicitacaoStr === 'Aceitar'">
                  Aguardando Análise
                </div>
                <div v-else-if="props.item.situacaoSolicitacaoStr === 'Rejeitar'">
                  Indeferida
                </div>
                <div v-else>
                {{ props.item.situacaoSolicitacaoStr }}
                </div>
            </td> 
            <td v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.tipoSolicitacaoStr }}</td>
            <td class="text-xs-left" nowrap v-if="(props.item && props.item.assinadoDigitalmente)"
              v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.assinadoDigitalmente == 1 ? "Sim" : "Não" }}   
            </td>
            <td class="text-xs-left" nowrap v-else
             v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ "Não" }}        
            </td>
            <td class="text-xs-left tdAnalista" nowrap>
              <div v-if="!$verificaPerfilHabilitadorMaster()">
                {{ props.item.nomAnalista}}
              </div>
              <div style="width:300px" v-if="$verificaPerfilHabilitadorMaster()  && !reload['combo_'+props.item.idFornecSolicitacao]">
                <v-combobox
                  v-model="props.item.usuarioAnalista"
                  :return-object="true"
                  :items="comboAnalistas"
                  item-text="nome"
                  @input="openModalAtribuirAnalista(props.item,false,'combo_'+props.item.idFornecSolicitacao)"
                  dense
                  validate-on-blur
                  v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}"
                ></v-combobox>
              </div>
            </td>
            <td class="text-xs-center" nowrap
              v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.unidadeSolicitacaoDescr ? props.item.unidadeSolicitacaoDescr : "-"}}
            </td>   
            <td class="text-xs-left" nowrap
              v-bind:class="{'dataVencida':props.item.validadeSolicitacao =='1'}">
              {{ props.item.nomPCF }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex>
        <v-icon color="grey">spellcheck</v-icon>
        <span>  - Aguardando Análise  </span>
        <v-icon color="red">list</v-icon>
        <span v-bind:class="{'dataVencida':true}">  Solicitação com mais de 05 dias úteis pendente de validação  </span>
      </v-flex>
    </v-card>
    <v-dialog v-model="dialogAtribuirAnalista.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirme!</v-card-title>
        <v-card-text>
          <div v-html="dialogAtribuirAnalista.texto()"></div>
          <strong>{{this.model.numSolicitacao}}</strong>.
        </v-card-text>
        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="success" @click="cancelarAtribuirAnalista()">Cancelar</v-btn>
          </v-flex>

          <v-flex sm6>
            <v-btn large color="info" @click="verificarSituacaoSolicitacao(dialogAtribuirAnalista.solicitacao)">Confirmar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUploadTermo.show" persistent max-width="520px" :key="dialogUploadTermoKey">
      <v-form ref="formTermo" v-model="validTermo">
        <v-card>
          <v-card-title class="tituloPopUpBaixar">Termo de Concordância e Veracidade</v-card-title>
          <v-card-text>
            <v-flex inputIcon v-show="!dialogUploadTermo.termo.file.novoUpload">
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.termo.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                clearable
                append-icon="get_app"
                readonly
                :rules="validaIfObrigatorio(!dialogUploadTermo.termo.file.novoUpload)"
                @click:clear="clearAnexo()"
                @click:append="baixarArquivo(dialogUploadTermo.termo.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex v-if="dialogUploadTermo.termo.file.novoUpload">
              <uploadFile
                tamanhoMaximo="20MB"
                required
                :label="$t('label.anexaDocumento')"
                v-model="dialogUploadTermo.termo.file.arquivoUpload"
                accept=".pdf, .PDF"
              />
            </v-flex>  
         
            <v-flex inputIcon v-if="dialogUploadTermo.docRGCPF != undefined ">
              <div class="tituloPopUpBaixar">RG, CPF ou documento equivalente</div>  
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.docRGCPF.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                
                append-icon="get_app"
                readonly
               
             
                @click:append="baixarArquivo(dialogUploadTermo.docRGCPF.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>

            <v-flex inputIcon v-if="dialogUploadTermo.procuracao != undefined">
              <div class="tituloPopUpBaixar">Procuração</div>  
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.procuracao.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
               
                append-icon="get_app"
                readonly
                
              
                @click:append="baixarArquivo(dialogUploadTermo.procuracao.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>

            <v-flex inputIcon v-if="dialogUploadTermo.estatuto != undefined && dialogUploadTermo.estatuto.arquivoUpload != null">
              <div class="tituloPopUpBaixar">Estatuto</div>  
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.estatuto.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                
                append-icon="get_app"
                readonly
                
                
                @click:append="baixarArquivo(dialogUploadTermo.estatuto.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>

            <v-flex inputIcon v-if="dialogUploadTermo.ata != undefined && dialogUploadTermo.ata.arquivoUpload != null">
              <div class="tituloPopUpBaixar">ATA</div>  
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.ata.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                
                append-icon="get_app"
                readonly
                
                
                @click:append="baixarArquivo(dialogUploadTermo.ata.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>

            <v-flex inputIcon v-if="dialogUploadTermo.contratoSocial != undefined && dialogUploadTermo.contratoSocial.arquivoUpload != null">
              <div class="tituloPopUpBaixar">Contrato Social</div>  
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.contratoSocial.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                
                append-icon="get_app"
                readonly
               
                
                @click:append="baixarArquivo(dialogUploadTermo.contratoSocial.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>

            <v-flex inputIcon v-if="dialogUploadTermo.cnpj != undefined && dialogUploadTermo.cnpj.arquivoUpload != null">
              <div class="tituloPopUpBaixar">CNPJ</div>  
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.cnpj.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                
                append-icon="get_app"
                readonly
                
              
                @click:append="baixarArquivo(dialogUploadTermo.cnpj.arquivoUpload,dialogUploadTermo.solicitacao.numCgcFornecedor)"
                persistent-hint
              ></v-text-field>
            </v-flex>

            <v-flex sm6>
              <v-btn small color="info" @click="BaixarTudo()">Baixar Tudo</v-btn>
            </v-flex>

          </v-card-text>
          <v-layout row p-b-15 p-t-10>
            <v-flex sm6>
              <v-btn large color="success" @click="closeModalUploadTermo()">Cancelar</v-btn>
            </v-flex>
            <v-flex sm6>
              <v-btn large color="info" @click="confirmarEnvioTermo()">Confirmar</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-form>
    </v-dialog>

    <dialogMotivoIndeferimento
      :config="modelDialogRejeitar"
      v-on:observacaoOk="rejeitar()"
      v-on:observacaoCancel="fnAcaoModalCancelar()"
    />
  </div>
</template>

<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import usuarioService from "../../../services/usuarioService";
import dominioService from "../../../services/dominioService";
import uploadDeclaracaoService from "../../../services/uploadDeclaracaoService";
import documentosService from "../../../services/documentosFornecService";

import Vue from 'vue';

export default {
  name: "veracidade-fornecedor",
  mixins: [util],
  components: { /*Componentes utilizados*/
    Migalha,
    Topo
  },
  created() /*Metodo de start do componente*/{
    if (!this.$verificaPerfilHabilitador()) {
      this.$toasted.error(this.$t("messages.validacao.usuarioSemPermissao"));
      this.$router.push("/loginrestrito");
    } else {
      if (this.$verificaPerfilHabilitador()) {
        usuarioService.getUsuariosHabilitador().then(response => { /*resposta do servico*/
          this.comboAnalistas = response.data; /*dados de retorno*/
          this.carregarTabelaCadastrados();
        });
      } else {
        this.carregarTabelaCadastrados();
      }
    }

    dominioService.geEnums().then(response => { /*resposta do servico*/
      this.enums = response.data; /*dados de retorno*/
      this.enumTtipoSolicitacao = this.enums.tipoSolicitacao.filter(x=>x.chave === "SolicitacaoNova" || x.chave === "SolicitacaoAlteracao");
    
      this.enumTtipoSolicitacao.filter(x => {
        if (x.chave === "SolicitacaoNova"){
          x.descricao = "Inscrição";}
      });
      this.enumSituacaoTermoVeracidade =  this.enums.situacaoTermoVeracidade.filter(x=>x.chave === "Aceitar" || x.chave === "Rejeitar"|| x.chave === "Aguardando");
      this.enumSituacaoTermoVeracidadeResumido = this.enums.situacaoTermoVeracidade.filter(x=>x.chave === "Aguardando");
    });

  },
  computed: {//Campos computados
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    comboAnalistasFiltro()
    {
      let combo = [{nome:'Todos', id: 0}];
      combo = combo.concat(this.comboAnalistas);
      return combo;
    }
  },
  data() {//Declaracao de variaveis
    return {
      enumTtipoSolicitacao:[],
      enumSituacaoTermoVeracidade:[],
      enumSituacaoTermoVeracidadeResumido:[],
      reload:{},
      dialogAtribuirAnalista: {
        show: false,
        nomeAnalista: "",
        nomeAnalistaAnterior: "",
        usuarioAnalistaId: null,
        tipos: { novo: 1, troca: 2, habilitador: 3 },
        solicitacao: {},
        tipo: 1,
        self:false,
        combo:null,
        texto: function() {
          var msg = "";

          switch (this.tipo) {
            case this.tipos.novo:
              msg =
                "Você confirma <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.troca:
              msg =
                "Você confirma a troca do analista <b>" +
                this.nomeAnalistaAnterior +
                "</b> para  <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.habilitador:
              msg = "Ao clicar em  <b>CONFIRMAR</b> essa solicitação ficará exclusiva para sua analise.";
              break;
          }
          return msg;
        }
      },
      dialogUploadTermoKey: 0,
      dialogUploadTermo: {
        show: false,
        termo:{
          idUploadDeclaracao: null,
          idFornecSolicitacao: null,
          tipDocumento: 150,
          uploadDeclaracaoSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null,
          file: {
            arquivoUpload: null,
            novoUpload: true
          }
        },
        docRGCPF:{
          idUploadDeclaracao: null,
          idFornecSolicitacao: null,
          tipDocumento: 150,
          uploadDeclaracaoSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null,
          file: {
            arquivoUpload: null,
            novoUpload: true
          }
        },
        procuracao:{
          idUploadDeclaracao: null,
          idFornecSolicitacao: null,
          tipDocumento: 150,
          uploadDeclaracaoSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null,
          file: {
            arquivoUpload: null,
            novoUpload: true
          }
        },
        estatuto:{
          id: null,
          idFornecSolicitacao: null,
          codDocumento: 143,
          ArquivoUploadSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null         
        },
        ata:{
          id: null,
          idFornecSolicitacao: null,
          codDocumento: 145,
          ArquivoUploadSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null         
        },
        contratoSocial:{
          id: null,
          idFornecSolicitacao: null,
          codDocumento: 146,
          ArquivoUploadSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null         
        },
        cnpj:{
          id: null,
          idFornecSolicitacao: null,
          tipDocumento: 1,
          ArquivoUploadSituacao: null,
          arquivoUpload: null,
          idMotivoIndeferimentoArquivo: null         
        },
        solicitacao: {},
      },
      modelDialogRejeitar: {
        open: false,
        obs: null,
        titulo: "Motivo",
        codDocumento:0,
        motivoSelecionado:0
      },      
      pagination: {
        rowsPerPage: 10,
        totalItems: 0,
        page: 1,
        descending: false,
        sortBy: "dataSolicitacao"
      },
      footerProps: {'items-per-page-options': [10]},
      valid: true,
      validTermo: true,
      enums: {},
      selected: [],
      headers: [ /*Cabeçalho da data-table*/
        {
          text: "Ações", width: 10, align: "center", sortable: false 
        },
        { 
          text: "CNPJ/CPF", width: 100, sortable: true, value: "numCgcFornecedor"
        },
        {
          text: "Razão Social/Nome", width: 400, sortable: true, value: "nomFornecedor"
        },
        { 
          text: "Nº Solicitação",  width: 100, sortable: true, value: "numSolicitacao"
        },
        {
          text: "Data Solicitação", width: 220, align: "center", sortable: true, value: "dataSolicitacao"
        },
        {  
          text: "Situação Solicitação", width: 100, sortable: true, value: "situacaoSolicitacaoStr" 
        },
        {
          text: "Tipo Solicitação", sortable: true, value: "tipoSolicitacaoStr" 
        },
        {
          text: "Assinatura Digital", width: 20, sortable: true, value: "assinadoDigitalmente"
        },      
        { 
          text: "Analista", width: 300, sortable: true, value: "nomAnalista"
        },
        { 
          text: "Unidade Solicitação", width: 300, sortable: true, value: "unidadeSolicitacaoDescr" 
        },
        {
          text: "Localidade", width: 20, sortable: true, value: "nomPCF"
        }
      ],
      model: {
        dataSolicitacao: null,
        dataFinalSolicitacao: null,
        situacaoSolicitacao: null,
        situacaoTermoVeracidade: null,
        tipFornecedor: null,
        numCgcFornecedor: null,
        nomFornecedor: null,
        nomPCF: null,
        numeroSolicitacao: null,
        analista: null,
        filtroAnalista: null,
        localidade: null,
        filtroSolicitacoesVencidas: '0',
      },
      listaFornec: [],
      paginaAtual: 1,
      totalItems: 0,
      comboAnalistas: [],
      analistaSelecionado: [],
      comboLocalidades: ['UEFS', 'UESB', 'UESC', 'SSA'],

    };
  },

  watch: { //Propriedades assistidas
  pagination: {
      handler(newValue, oldValue) {
        if (Object.keys(oldValue).length > 2) {
          this.pagination.sortBy = newValue.sortBy;
          this.pagination.descending = newValue.descending ? true : false;
          this.carregarTabelaCadastrados();
        }
      }
    },
  
    "model.analista": {
      handler(newValue, oldValue) {
        if(newValue !== oldValue){
          if(newValue == null || newValue.id === 0){
            this.model.filtroAnalista = null;
          }else{
            this.model.filtroAnalista = newValue.nome;
          }
        }
      }
    },
    "pagination.page": {
      handler() {
        this.carregarTabelaCadastrados();
      },
      deep: true
    }
  },

  methods: {//Declaracao de todos os metodos
    exportarExcel(){
      // 3 - gera excel de solicitações da tela de termo e concordância.
      fornecedorService.exportarExcel(this.model, 3);
    },
    getCpfCnpjMask() {
    if (this.model.tipFornecedor === 'J') {
      return {
        mask: 'XX.XXX.XXX/XXXX-##',
        tokens: {
          'X': { 
            pattern: /[0-9a-zA-Z]/, 
            persistent: true,
            transform: (char) => char.toUpperCase()  // ✅ Aqui também
          }
        }
      }
    } else if (this.model.tipFornecedor === 'F') {
      return {
        mask: '###.###.###-##',
        tokens: {
          '#': { pattern: /\d/, persistent: true }
        }
      }
    }
    return '##############'
  },
    BaixarTudo(){
      if(this.dialogUploadTermo.procuracao != undefined){
        this.baixarArquivo(this.dialogUploadTermo.procuracao.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }
      if(this.dialogUploadTermo.docRGCPF != undefined){
        this.baixarArquivo(this.dialogUploadTermo.docRGCPF.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }

      if(!this.dialogUploadTermo.termo.file.novoUpload){
        this.baixarArquivo(this.dialogUploadTermo.termo.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }
      if(this.dialogUploadTermo.estatuto != undefined && this.dialogUploadTermo.estatuto.arquivoUpload != null){
        this.baixarArquivo(this.dialogUploadTermo.estatuto.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }
      if(this.dialogUploadTermo.ata != undefined && this.dialogUploadTermo.ata.arquivoUpload != null){
        this.baixarArquivo(this.dialogUploadTermo.ata.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }
      if(this.dialogUploadTermo.contratoSocial != undefined && this.dialogUploadTermo.contratoSocial.arquivoUpload != null){
        this.baixarArquivo(this.dialogUploadTermo.contratoSocial.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }
      if(this.dialogUploadTermo.cnpj != undefined && this.dialogUploadTermo.cnpj.arquivoUpload != null){
        this.baixarArquivo(this.dialogUploadTermo.cnpj.arquivoUpload,this.dialogUploadTermo.solicitacao.numCgcFornecedor)
      }
    },
    carregarTabelaCadastrados(pesquisar) {
      //carregar a listagem de fornecedor
    
      if (pesquisar) {
        this.pagination.page = 1;

        if (!this.$refs.formPesquisar.validate()) return;
      }

      this.$mostrarPreload(); /*Exibir o PreLoad*/
   
      this.model.page = this.pagination.page;
      this.model.rowsPerPage = this.pagination.rowsPerPage;
      this.model.sortBy = this.pagination.sortBy;
      this.model.descending = this.pagination.descending;
      this.model.filtroAguardandoAnalise = true;
      this.model.situacaoSolicitacao = this.model.situacaoTermoVeracidade;

      fornecedorService.getSolicitacaoFornecedor(this.model)
        .then(response => { /*resposta do servico*/
          this.listaFornec = response.data.fornecedorLista.filter(x => !(x.unidadeSolicitacaoDescr != null && x.situacaoSolicitacao === 9));
          this.pagination.totalItems = response.data.totalItems;
          this.listaFornec.forEach((item) => {
            item.usuarioAnalista = this.comboAnalistas.find(
              x => x.id == item.usuarioAnalistaId
            );
          this.$set(this.reload,'combo_'+item.idFornecSolicitacao,false);
          });
          this.$removePreload(); /*Ocultar o PreLoad*/
        })
        .catch(error => {
          this.$removePreload(); /*Ocultar o PreLoad*/
          if (error.status == 403) {
              Vue.toasted.error("Acesso não permitido!");
              this.$router.push("/arearestrita/habilitador/solicitacao");
          }
        });
    },

    editItem(idFornecSolicitacao) {
      //editar a solicitacao
        this.$router.push({
          path: `/arearestrita/habilitador/consultar-solicitacao/${idFornecSolicitacao}`
        });
      },

    atribuirAnalistaFornecedor() {
      //associar a solicitacao a um habilitador
      fornecedorService
        .atribuirAnalistaFornecedor(
          this.dialogAtribuirAnalista.solicitacao,
          this.dialogAtribuirAnalista.usuarioAnalistaId
        )
        .then(response => { /*resposta do servico*/
          if (this.$verificaPerfilHabilitadorMaster()) {
            if( this.dialogAtribuirAnalista.self){
              this.editItem(response.data.idFornecSolicitacao);
              return;
            }
            this.$toasted.success(this.$t("messages.cadastro.analistaAssociado"));
            this.cancelarAtribuirAnalista();
          } else {
            this.editItem(response.data.idFornecSolicitacao);
          }
        });
    },

    verificarSituacaoSolicitacao(solicitacao) {
      //verificar a situacao da solicitacao
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService
        .getSolicitacao(solicitacao.idFornecSolicitacao)
        .then(response => { /*resposta do servico*/
          let sit
          // solicitacao.tipoSolicitacao tipo number
          if (solicitacao.tipoSolicitacao === 2) // Se for Alteração
            sit = response.data.novoModel.situacaoSolicitacao
          else
            sit = response.data.situacaoSolicitacao

          if (sit === 2 || sit === 3 ){ // 2 === aguardando analise, 3 === em analise, tipo number
            this.atribuirAnalistaFornecedor()
          } else {
            Vue.toasted.error("Esta solicitação não está mais disponível.");
            this.carregarTabelaCadastrados();
            this.dialogAtribuirAnalista.show = false;
          }
          this.$removePreload(); /*Ocultar o PreLoad*/
        }).catch(() => {
            this.carregarTabelaCadastrados();
            this.dialogAtribuirAnalista.show = false;
            this.$removePreload(); /*Ocultar o PreLoad*/
        })

    },
    atualizarSituacaoSolicitacao(fornecedorSolicitacao, idSituacaoSolicitacao) {
      this.$mostrarPreload();
      
      var fornecedorSolicitacaoAux = fornecedorSolicitacao;
      
      fornecedorSolicitacaoAux.situacaoSolicitacao = idSituacaoSolicitacao;
      
      fornecedorService
        .atualizarSituacaoSolicitacao(fornecedorSolicitacaoAux)
        .then(response => {
          this.carregarTabelaCadastrados();
          this.$removePreload();
        }).catch(() => {
          this.carregarTabelaCadastrados();
          this.$removePreload();
        })
    },
    defineCorIconeSolicitacao(idSituacaoSolicitacao) {
      switch (idSituacaoSolicitacao) {
        case 2: return 'grey'
        case 3: return 'blue'
        case 9: return 'green'
        case 10: return 'red'
        default: return 'grey'
      }
    },
    
    openModalAtribuirAnalista(solicitacao,self,combo) {
      //abrir confirmação da associação de um novo analista
      if (this.$verificaPerfilHabilitadorMaster()) {

        if(self){
        this.dialogAtribuirAnalista.solicitacao = solicitacao;
        this.dialogAtribuirAnalista.show = true;
        this.dialogAtribuirAnalista.tipo = 3;
        this.dialogAtribuirAnalista.self = true;
        this.dialogAtribuirAnalista.usuarioAnalistaId = this.$store.getters.getUsuarioId

        return;
        }

        if (solicitacao.usuarioAnalista) {
          this.setAnalista(solicitacao, combo);
        }
      } else if (this.$verificaPerfilHabilitador()) {
        this.dialogAtribuirAnalista.solicitacao = solicitacao;
        this.dialogAtribuirAnalista.show = true;
        this.dialogAtribuirAnalista.tipo = 3;
      }
    },

    setAnalista(solicitacao, combo){
      if (typeof solicitacao.usuarioAnalista == "object") {
        this.dialogAtribuirAnalista.tipo = 1;

        if (
          solicitacao.usuarioAnalistaId &&
          solicitacao.usuarioAnalista.id !== solicitacao.usuarioAnalistaId // variaveis do tipo number
        ) {
          this.dialogAtribuirAnalista.nomeAnalistaAnterior = solicitacao.nomAnalista;
          this.dialogAtribuirAnalista.tipo = 2;
        }

        this.dialogAtribuirAnalista.nomeAnalista = solicitacao.usuarioAnalista.nome;
        this.dialogAtribuirAnalista.usuarioAnalistaId = solicitacao.usuarioAnalista.id;
        this.dialogAtribuirAnalista.solicitacao = solicitacao;
        this.dialogAtribuirAnalista.show = true;
      } else {
        if (combo) {
          this.reload[combo] = true;
        }

        this.cancelarAtribuirAnalista();
      }
    },

    cancelarAtribuirAnalista() {
      //cancelar a associacao de analista
      this.dialogAtribuirAnalista.nomeAnalista = "";
      this.dialogAtribuirAnalista.show = false;
      this.dialogAtribuirAnalista.usuarioAnalistaId = null;
      this.dialogAtribuirAnalista.solicitacao = {};
      this.carregarTabelaCadastrados();
    },

    fnPodeValidar(item) {//verificar se a solicitacoa pode ser validada
      if (this.$verificaPerfilHabilitador() &&
          item.situacaoSolicitacao !== 3 && item.usuarioAnalistaId == null //item.situacaoSolicitacao é tipo number
          ) { // 3 === em analise
        return true;
      }

      return false;
    },

    fnPodeContinuarValidar(item) {
      //verificar se pode ser continuada a validação da solicitacao
      if (this.$verificaPerfilHabilitador() &&
          (item.situacaoSolicitacao === 3 && //item.situacaoSolicitacao é tipo number
            String(item.usuarioAnalistaId) === this.$store.getters.getUsuarioId) //item.usuarioAnalistaId= number, $store.getters.getUsuarioId= string
          ) {
        return true;
      }
      return false;
    },

    openModalUploadTermo(solicitacao){
      this.$mostrarPreload();
      this.clearModelTermo();
      this.clearAnexo();
      this.dialogUploadTermo.solicitacao = solicitacao;

      documentosService
        .getDocumentosFornecedorSolicitacao(solicitacao.idFornecSolicitacao)
        .then(documentos => {        
          var estatuto = documentos.data.find(x=>x.codDocumento == 143)          
          this.dialogUploadTermo.estatuto = estatuto.docSolicitacao
          var ata = documentos.data.find(x=>x.codDocumento == 145)          
          this.dialogUploadTermo.ata = ata.docSolicitacao
          var contratoSocial = documentos.data.find(x=>x.codDocumento == 146)          
          this.dialogUploadTermo.contratoSocial = contratoSocial.docSolicitacao
        });
      
        fornecedorService.getRegularidadeFiscalTipoDoc(solicitacao.numCgcFornecedor, 111).then(response => { /*resposta do servico*/
      
          this.dialogUploadTermo.cnpj = response.data; 
          
           }).catch(error => {
        });
     
      uploadDeclaracaoService.consultaListaTermoFornecedor(solicitacao.idFornecSolicitacao).then(
        response => {        
          
          if(response.data != null && response.data.length > 0 ){
          
            this.dialogUploadTermo.termo = response.data.find(x =>x.tipDocumento == 150) || {
              idUploadDeclaracao: null,
              idFornecSolicitacao: solicitacao.idFornecSolicitacao,
              tipDocumento: 150,
              uploadDeclaracaoSituacao: null,
              arquivoUpload: null,
              idMotivoIndeferimentoArquivo: null,
              file: {
                arquivoUpload: null,
                novoUpload: true
              }
            };
            this.dialogUploadTermo.docRGCPF = response.data.find(x =>x.tipDocumento == 162)|| {};
            this.dialogUploadTermo.procuracao = response.data.find(x =>x.tipDocumento == 161)|| {};

            if(!!this.dialogUploadTermo.termo.arquivoUpload && this.dialogUploadTermo.termo.dtRejeicao == null){
              this.dialogUploadTermo.termo.file = {
                arquivoUpload: null,
                novoUpload: false
              }
            }else{
              this.dialogUploadTermo.termo.file = {
                arquivoUpload: null,
                novoUpload: true
              }
            }

            if(this.dialogUploadTermo.docRGCPF != undefined){
              this.dialogUploadTermo.docRGCPF.file = {
                arquivoUpload: null,
                novoUpload: false
              }
            }

            if(this.dialogUploadTermo.procuracao != undefined){
              this.dialogUploadTermo.procuracao.file = {
                arquivoUpload: null,
                novoUpload: false
              }
            }

            this.dialogUploadTermo.termo.dtRejeicao = null;

           
          }else{
            this.dialogUploadTermo.termo.idFornecSolicitacao = solicitacao.idFornecSolicitacao;
          }
          this.$removePreload();
          this.dialogUploadTermoKey++;
          this.dialogUploadTermo.show = true;
        }
      );
    


    },

    closeModalUploadTermo(){
      this.clearModelTermo();
      this.clearAnexo();
      this.dialogUploadTermo.show = false;
    },

    clearModelTermo(){
      this.dialogUploadTermo.termo = {
        idUploadDeclaracao: null,
        idFornecSolicitacao: null,
        tipDocumento: 150,
        uploadDeclaracaoSituacao: null,
        arquivoUpload: null,
        idMotivoIndeferimentoArquivo: null,
        file: {
          arquivoUpload: null,
          novoUpload: true
        }
      };

      this.dialogUploadTermo.docRGCPF = {
        idUploadDeclaracao: null,
        idFornecSolicitacao: null,
        tipDocumento: 150,
        uploadDeclaracaoSituacao: null,
        arquivoUpload: null,
        idMotivoIndeferimentoArquivo: null,
        file: {
          arquivoUpload: null,
          novoUpload: true
        }
      };

      this.dialogUploadTermo.procuracao = {
        idUploadDeclaracao: null,
        idFornecSolicitacao: null,
        tipDocumento: 150,
        uploadDeclaracaoSituacao: null,
        arquivoUpload: null,
        idMotivoIndeferimentoArquivo: null,
        file: {
          arquivoUpload: null,
          novoUpload: true
        }
      };
      this.dialogUploadTermo.solicitacao = {};
    },

    clearAnexo(){
      this.dialogUploadTermo.termo.arquivoUpload = null;
      this.dialogUploadTermo.termo.file.novoUpload = true;
      this.dialogUploadTermo.termo.file.arquivoUpload = null;
    },

    baixarArquivo(arquivo,cgc){
      fornecedorService.baixarArquivo(arquivo,cgc);
    },

    confirmarEnvioTermo(){
      if( 
          this.dialogUploadTermo.termo.file.novoUpload === false || 
          (this.dialogUploadTermo.termo.file.novoUpload === true && this.dialogUploadTermo.termo.file.arquivoUpload == null )
        )
      {
        this.closeModalUploadTermo();
        return;
      }

      if(this.$refs.formTermo.validate()){
      
        var model = {uploadDeclaracao: this.dialogUploadTermo.termo, file: this.dialogUploadTermo.termo.file};

      
        uploadDeclaracaoService.salvarTermo(model).then(
          response => {
            this.closeModalUploadTermo();
            this.$toasted.success(this.$t("messages.cadastro.cadastroDocumentoSucesso"));
            this.carregarTabelaCadastrados();
          }
        ).catch(error => {
          this.closeModalUploadTermo();
           this.carregarTabelaCadastrados();
        });
      }
    
    },

    validaIfObrigatorio(valida){
      if(valida){
        
        return this.validacao.campoObrigatorio;
      }
      return [];
    },

    exibeErroTermo(){
      this.$toasted.error("Anexe o Termo de Concordância e Veracidade.");
    },

    openModalRejetar(solicitacao) {
      this.$mostrarPreload();
      uploadDeclaracaoService.consultaTermoFornecedor(solicitacao.idFornecSolicitacao).then(response => {
        this.modelDialogRejeitar.termo = response.data;
        this.modelDialogRejeitar.open = true;
        this.modelDialogRejeitar.codDocumento = 150;
        this.modelDialogRejeitar.motivoSelecionado = response.data.idMotivoIndeferimentoArquivo;
      });
      this.$removePreload(); 
    },

    //metodo para rejeitar o termo
    rejeitar() {
      this.$mostrarPreload();
      let model =  {uploadDeclaracao: this.modelDialogRejeitar.termo};
      model.uploadDeclaracao.uploadDeclaracaoSituacao = 1;
      model.uploadDeclaracao.idMotivoIndeferimentoArquivo = this.modelDialogRejeitar.motivoSelecionado;

      uploadDeclaracaoService.aprovarRejeitarTermo(model).then(response => { /*resposta do servico*/
        this.fnAcaoModalCancelar();
        this.$removePreload(); 
        this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
        this.carregarTabelaCadastrados();
      }).catch(()=>{
        this.$removePreload();
        this.fnAcaoModalCancelar();
        this.carregarTabelaCadastrados();
      });
 
    },

    fnAcaoModalCancelar() {
      this.modelDialogRejeitar.termo = {};
      this.modelDialogRejeitar.open = false;
    }

  }

};
</script>

<style>
.tableLista .v-table {
  width: auto !important;
  max-width: none !important;
}

.tdAnalista .v-text-field,
.tdAnalista .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
}

.tdAnalista .v-messages {
  display: none;
}

.tdAnalista .error--text  .v-input__slot::before,
.tdAnalista .error--text  .v-select__slot::before {
  border: solid 1px #ff5252!important;
}

.tituloPopUpBaixar {
  font-size: 20px; /* Defina o tamanho da fonte desejado aqui */
  font-weight: bold;
}

</style>
